import React from "react";

import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { Input } from "./input";
import { Search } from "./search";
import { Resources } from "./resources";
import styles from "./styles.scss";

function ResourceSelection({
  resources,
  selected,
  placeholder,
  onSelect,
}: Props) {
  const [search, setSearch] = React.useState("");

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.list}>
      {({ isOpen, select }) => ({
        input: (
          <Input
            placeholder={placeholder}
            selected={selected}
            isOpen={isOpen}
          />
        ),
        list: (
          <div className={styles.resourcesSelection}>
            <div className={styles.search}>
              <Search search={search} setSearch={setSearch} />
            </div>
            <Resources
              resources={resources}
              search={search}
              selected={selected}
              onSelect={(resource) => {
                select(resource);
                onSelect(resource);
              }}
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ResourceSelection };
